import { automationTherapistResponse } from '@/modules/permissionsToogle/domain/models/automationTherapistResponse'

import { axios, Response } from '../index'

const updatePermissionTherapist = (
  therapistId: string
): Response<automationTherapistResponse> => {
  return axios.put(`/v1/automation-therapist/${therapistId}`, therapistId)
}
export default updatePermissionTherapist
